import { hasArrayValues } from 'utils/array/arrays';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toArray = <T = unknown>(v: any): T[] => {
  if (hasArrayValues<T[]>(v)) {
    return v;
  }

  if (hasArrayValues<T[]>(v?.results)) {
    return v.results;
  }

  if (hasArrayValues<T[]>(v?.items)) {
    return v.items;
  }

  return [];
};
